export default "__VITE_ASSET__Js2v8W$P__"